// Import polyfill for Intl.PluralRules to support plurals in older browsers
import "intl-pluralrules";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import * as germanTranslation from "./locales/de.json";
import * as englishTranslation from "./locales/en.json";
import * as spanishTranslation from "./locales/es.json";
import * as frenchTranslation from "./locales/fr.json";
import * as italianTranslation from "./locales/it.json";
import * as swedishTranslation from "./locales/sv.json";

// tip: manage languages separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const resources = {
  en: {
    translation: englishTranslation,
  },
  sv: {
    translation: swedishTranslation,
  },
  es: {
    translation: spanishTranslation,
  },
  fr: {
    translation: frenchTranslation,
  },
  de: {
    translation: germanTranslation,
  },
  it: {
    translation: italianTranslation,
  },
};

// Language options for the language selector
export const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "sv", name: "Svenska", flag: "🇸🇪" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    compatibilityJSON: "v4",
    resources,
    fallbackLng: "en",

    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    // Enable pluralization support
    pluralSeparator: "_",
    contextSeparator: "_",
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
      ],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;
